import { render } from "./FenceView.vue?vue&type=template&id=24540b90&scoped=true"
import script from "./FenceView.vue?vue&type=script&lang=js"
export * from "./FenceView.vue?vue&type=script&lang=js"

import "./FenceView.vue?vue&type=style&index=0&id=24540b90&scoped=true&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24540b90"]])

export default __exports__